import { render, staticRenderFns } from "./dialog-table-file.vue?vue&type=template&id=012780e8&scoped=true&"
import script from "./dialog-table-file.vue?vue&type=script&lang=js&"
export * from "./dialog-table-file.vue?vue&type=script&lang=js&"
import style0 from "./dialog-table-file.vue?vue&type=style&index=0&id=012780e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012780e8",
  null
  
)

export default component.exports